// eslint-disable-next-line
export const VIEWS = {
  LIST: 'list',
  LINK: 'link',
  ADD: 'add',
  EDIT: 'edit',
  PLAID: 'plaid',
};

export const RETIREMENT_ACCOUNTS = [5, 7, 25, 26, 17, 19, 27, 4, 22, 10, 23, 11];
export const RETIREMENT_EARMARK = { Tooltip: 'Retirement', Type: 'Retirement' };
export const RETIREMENT_TYPE = 'Retirement';
